import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
const BASE_URL = process.env.REACT_APP_API_URL;
const AllOrders = () => {
  const [orders, setOrders] = useState([]);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const agentId = query.get('agentId');

  useEffect(() => {
    if (!agentId) return;

    const fetchOrders = async () => {
      try {
        const gmResponse = await axios.get(`${BASE_URL}/api/agents?id=${agentId}`);
        const mobResponse = await axios.get(`${BASE_URL}/api/mobility?id=${agentId}`);

        const mappedMob = (mobResponse.data || []).map(order => ({
          Order_Number: order.ORDER_REF_NO,
          SEGMENT: "MOB",
          Activation_Date: order.GM_ACTIVATION_DT,
          Units: "0.5",
          Agent_Name: order.FULL_NAME,
        }));

        const combined = [...gmResponse.data, ...mappedMob];
        setOrders(combined);
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    };

    fetchOrders();
  }, [agentId]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 text-white px-6 py-14">
      <div className="max-w-5xl mx-auto bg-white/5 border border-white/10 rounded-2xl p-8 shadow-2xl">
        <h1 className="text-3xl font-bold mb-8 text-center">Order Details for Agent {agentId}</h1>

        {orders.length === 0 ? (
          <p className="text-center text-red-400">No orders found for Agent ID {agentId}</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-600">
              <thead>
                <tr className="text-left text-sm text-gray-300">
                  <th className="px-4 py-2">Order Number</th>
                  <th className="px-4 py-2">Segment</th>
                  <th className="px-4 py-2">Date of Installation</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-700">
                {orders.map((order, idx) => (
                  <tr key={`${order.Order_Number}-${order.SEGMENT}-${idx}`} className="hover:bg-white/10">
                    <td className="px-4 py-3 text-white font-medium">{order.Order_Number}</td>
                    <td className="px-4 py-3 text-white">{order.SEGMENT}</td>
                    <td className="px-4 py-3 text-white">{new Date(order.Activation_Date).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllOrders;
